
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import axios from 'axios';
import Signup from './Signup';
import Configdata from './Defaultdata';

import {isvalidatemail,isvalidmob,isvaluenull,isvaliduser} from './validation';
import { getmessage,wrongmsg,getusertype,searchpostnow,clearform,gtlclstor } from './Dynamictable';
import { cityidfromcod } from './userdefaultdata';
import Usersession from './Usersession';
import Forgotpassword from './Forgotpassword'
import Search from './Search';
import {unmountComponentAtNode} from 'react-dom';
import Home from './Home';

class Register extends Component {
	constructor(props: any) {
   	super(props);
	this.state.togglesineup = false;
    	this.state.ltypeguest = false;

  	}
	state = {
        name: "",
	email:"",
	paswrd:"",
	mlorph:"",
        togglecrit: false,
        togglesineup:false,
	slcttype:false,
	ltypeguest:false
	
	
    	};

	guestlogindivshow(){
		this.setState({ ltypeguest: true });
		this.displayenrtryname(1);
		this.displayenrtryemail(1);
		this.displayenrtrypass(0);

	}
        logindivshow(){

         	 this.setState({ slcttype: true });
		this.setState({ ltypeguest: false });
		this.displayenrtryname(0);
		this.displayenrtryemail(1);
		this.displayenrtrypass(1);
		
	}
	typeselect(e: any){
		
		this.desecttypes();
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';

		//alert(eid);
		if(eid == 'loginguestdiv')
		{
		 this.guestlogindivshow();
		
		}
		else if(eid == 'loginuserdiv'){
		this.logindivshow();
		//this.setState({ slcttype: true });
		//this.setState({ ltypeguest: false });
		//this.displayenrtryname(0);
		//this.displayenrtryemail(1);
		//this.displayenrtrypass(1);
		
		}
		else if(eid == 'searchlease'){
		this.setState({ slcttype: true });
		
		}
		else if(eid == 'searchservice'){
		this.setState({ slcttype: true });
		}

		e.preventDefault()

	};
	usersineup(e: any){
	   try {
		
		const signups = <Signup />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(signups,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};
	forgotpswd(e: any){
	   try {
		if(!isvaliduser()){
		  getmessage('Please Login with authorize user','');
		}
		else{
		const forgotpswd = <Forgotpassword />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(forgotpswd,Pdivr);
		maindiv.style.display = 'none';
		Pdivr.style.display = 'block';
	     }
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};

	iregctrlsvalidate(tp: any){
	 let isvalid = true;
	 let mailorphone = false;	
		if(isvalidatemail(this.state.email)){
			 mailorphone = true;
			 this.setState({ mlorph: 'mail' });
		}
		 if(isvalidmob(this.state.email)){
			 mailorphone = true;
			this.setState({ mlorph: 'ph' });
		}
		if(mailorphone != true) {
		getmessage('Please enter a valid email or phone no.','');
	  	return false;

		}
		if(tp == 'autho'){
		if(isvaluenull(this.state.paswrd)){
		 getmessage('password should not blank','');
	  	return false;
		}
		}	
	return isvalid;
	}
	

	desecttypes(){
		this.setState({ slcttype: false });
		const gstuser = document.getElementById('loginguestdiv') as HTMLElement;
		const logonuser = document.getElementById('loginuserdiv') as HTMLElement;
		gstuser.style.backgroundColor = 'gray';
		logonuser.style.backgroundColor = 'gray';

		
	}
	displayenrtryname(d: any){
	const unamedv = document.getElementById('unamediv') as HTMLElement;

	 if(d == 0) unamedv.style.display = 'none';
	 else 	unamedv.style.display = 'block';

	}
	displayenrtryemail(d: any){
	const umail = document.getElementById('uemailodiv') as HTMLElement;

	 if(d == 0) umail.style.display = 'none';
	 else 	umail.style.display = 'block';

	}
	displayenrtrypass(d: any){
	const upass = document.getElementById('upassdiv') as HTMLElement;

	 if(d == 0) upass.style.display = 'none';
	 else 	upass.style.display = 'block';

	}


	componentDidMount() {
        //debugger;
	
     	 //this.guestlogindivshow();
	this.logindivshow();
     
    	}

	textboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(id);
        if(id == 'txtusername'){
        
	 this.setState({ name: elvalue });
	}
	else if(id == 'txtusermail'){
	
	 this.setState({ email: elvalue });
	}
	
	else if(id == 'txtpassword'){
	
	 this.setState({ paswrd: elvalue });
	
	}
	
   }

setuserlogin(e:any){

 if(this.state.ltypeguest == true){
	this.insertuserguest();
  }
  else{
    this.setlogintouser();
  }
  		
  e.preventDefault()
}
setlogintouser(){
 	
	this.loginauthouser();
	localStorage.setItem("ltype",'authorized');
}
setuserauthority(usrcode:any,usrtype: any,usrpoints:any,usroffer: any){
        
        const username = this.state.name;
        const usermail = this.state.email;
	const userinfo ={id:"NA",uname:username,utype: usrtype,upoints: usrpoints,offer:     	usroffer,ltype:'unauthorized',phone:"",mailid:usermail,mailvrfy:'0',phonevrify:'0'};
        const struserinfo = JSON.stringify(userinfo);
	localStorage.setItem("userinfo",struserinfo);
	localStorage.setItem("id","NA");
       
}
setlogininfo(usrallcodes:any){
	const arrcodes = usrallcodes.split(':');
        const usrcode = arrcodes[0];
        const usrpoints = arrcodes[1];
	
	const usroffer = arrcodes[2];
        const cod = usrcode;
        const utp = usrcode[0];
	Usersession.setUsertypeid(utp);
	
        const ucode = usrcode.substring(0,(usrcode.length -4));
	const usrtype = getusertype(utp);
	const uphone = arrcodes[3];
	
	const usrname = arrcodes[4];
        const ismailvrify = arrcodes[5];
	const isphonevrify = arrcodes[6];
	const usermail = this.state.email;
		
	const userinfo ={id:ucode,uname:usrname,utype: usrtype,upoints: usrpoints,offer: usroffer,ltype:'authorized',phone:uphone,mailid:usermail,mailvrfy:ismailvrify,phonevrify:isphonevrify};
        const struserinfo = JSON.stringify(userinfo);
	localStorage.setItem("userinfo",struserinfo);
       //alert(usrcode);
        localStorage.setItem("id",usrcode);
	//getmessage(usrcode,'');
	//localStorage.setItem("offerid",usroffer);
	//localStorage.setItem("points",usrpoints);
	//localStorage.setItem("utype",usrtype);
	//localStorage.setItem("ltype",'authorized');
	const citycode = ucode.substring(1,4);
	const ctid = cityidfromcod(citycode);
	Usersession.setCityId(ctid);
	
	
	
}

insertuserguest(){
	 try {
                let url = Configdata.srvurl + '/insertguestuser';
		if(this.iregctrlsvalidate('na')){
          	getmessage('On Process Please wait.....','');	
		const mailid = this.state.email;
		
                const response = axios.post(url, {
    		uname: this.state.name,
    		
    		uemail: mailid
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		 Usersession.setGuestmailid(mailid);
		getmessage(usercd,'');
		this.setuserauthority(usercd,'guest','0','0');
		const vld = clearform('frmlogin');
		//Usersession.setCityId("1");
		this.getdatasearch();
		
	        });		
              }
		
	   }
          }
        catch (exp:any) {
           // debugger;
		wrongmsg();
        }
}
loginauthouser(){
	 try {
	        let url = '';
		if(this.iregctrlsvalidate('na')){
          	getmessage('On Process Please wait.....','');	
		const mailid = this.state.email;
		if(this.state.mlorph == '')
		    return false; 		
		if(this.iregctrlsvalidate('autho')){
          	getmessage('On Process Please wait.....','');	

		//alert(this.state.mlorph);
		const userpaswrd = this.state.paswrd.trim();
		const usermail = this.state.email.trim();
                const response = axios.post(Configdata.srvurl + '/loginusertrasc', {
    		pass: userpaswrd,
    		mlph: this.state.mlorph,
    		uemail: usermail
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		//getmessage(usercd,'test');
		if(usercd == 'NA'){
		getmessage('Wrong mail id/phone or password','');
		}
		else{
		//getmessage(usercd,'');

		getmessage('Login successful','');
		this.setlogininfo(usercd);
		this.getdatasearch();
		}
		
		
	        });		
              }
	     }	
	   }
          }
        catch (ex:any) {
           // debugger;
		wrongmsg();
        }
}
gotosearchprpty(e:any){
        let criterias = Usersession.getSearchopts();
        
	//criterias["ctid"] = "1";
	
	// criterias["localid"] = "1";
	// Usersession.setType("1");
	// Usersession.setCityId("1");
	//criterias["trnstpid"]="1";
       // criterias["postedby"]="1";
	//Usersession.setSearchopts(criterias);
	const homemain = document.getElementById('container') as HTMLElement;
      
	homemain.style.display = 'block';
	const Pdivc = document.getElementById('profilediv') as HTMLElement;
	if(Pdivc)
	Pdivc.style.display = 'none';
	if(homemain){
	unmountComponentAtNode(homemain);
	const srch = <Home />;
	ReactDOM.render(srch,homemain);	
	}
   }
	
getdatasearch(){

this.gotosearchprpty(0);
 }	
     closeprofilediv(){
	const Pdivr = document.getElementById('profilediv') as HTMLElement;
	Pdivr.style.display ='none';
     }

	render() {
		return (
		<form id="frmlogin">
			
                <div id="sinupsidebardiv" className="sidebar-search" style={{width:'80vw'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			  SignIn
			</div>
			
	   	     </div>
		  <div id="selectlogintype" className="sidebar-scroll">
		   	
		     <div className="sidebar-basic-info" style={{width:'100%'}}>
		       <div> 
			<a href="#" id="guestlogintype" onClick={e => this.typeselect(e)} title="Guest">

                       	<div className="searchtype" id="loginguestdiv" >
			  Guest	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="authorized">

			<div className="searchtype" id="loginuserdiv" style={{backgroundColor:'green'}}>
			  Authoriz	
			</div>
			</a>
		     </div>
		    </div>
		   <div className="sidebar-basic-info" id="unamediv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginusername" style={{width:'94%'}}>
			  <input placeholder="Enter Name"  onChange={e => this.textboxChange(e)} id="txtusername" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>

		   <div className="sidebar-basic-info" id="uemailodiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginuseremail" style={{width:'94%'}}>
			  <input placeholder="Enter email/Phone"  onChange={e => this.textboxChange(e)} id="txtusermail" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
		     <div className="sidebar-basic-info" id="upassdiv" style={{width:'90%',marginTop:'3vh'}}>
		       <div>	
			 <div className="searchtype" id="userpassworddiv" style={{width:'94%'}}>
			  <input placeholder="Enter password"  onChange={e => this.textboxChange(e)} id="txtpassword" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
	
		   
		   	
		     <div className="sidebar-basic-info" style={{width:'100%' ,marginTop:'5vh',height:'60px'}}>
		       <div> 
			

                       	<div id="signupdiv" style={{width:'55%',float:'left',padding:'10px'}}>
			<a href="#" onClick={e => this.forgotpswd(e)} title="forgot password">forgot password</a> &nbsp;&nbsp;&nbsp;
			<a href="#" onClick={e => this.usersineup(e)} title="SignUp">SignUp</a> &nbsp;
			
			

			</div>
			
			<a href="#" onClick={e => this.setuserlogin(e)} title="Sale">

			<div className="searchtype" id="usersignin" style={{width:'28%',float:'left'}}>
			  LogIn	
			</div>
			</a>
		     </div>
		    </div>

 		   


		 </div>
	      </div>

		

		</form>
		);
	}

	
}

export default Register;
